import Header from "./Header";
import Loading from "./Loading";
import {useEffect, useState} from "react";
import {Download} from "lucide-react";
import {CgExport} from "react-icons/cg";
import {BiPaperPlane} from "react-icons/bi";
import {useNavigate} from "react-router-dom";
import {certifyManuscriptCall, fetchManuscript} from "../service/ManuscriptService";
import {calculateOverallScore} from "../service/Operations";


function ExportCenter() {

    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const [loading, setLoading] = useState(true);
    const [manuscript, setManuscript] = useState(null);
    const [manuscriptError, setManuscriptError] = useState(false);
    const [certifyError, setCertifyError] = useState(false);
    const [certifyBanner, setCertifyBanner] = useState(false);


    useEffect(() => {
        setLoading(true);
        setManuscriptError(false);
        setCertifyError(false);
        setCertifyBanner(false);
        fetchManuscript(id, true)
            .then(response => {
                if (response.manuscript) {
                    setManuscript(response.manuscript);
                } else {
                    setManuscriptError(true)
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [])

    function certifyManuscript() {
        setLoading(true);
        setManuscriptError(false);
        setCertifyError(false);
        setCertifyBanner(false);
        certifyManuscriptCall(id, true)
            .then(response => {
                if (response.manuscript != null && response.success === true) {
                    setManuscript(response.manuscript);
                    setCertifyBanner(true);
                } else {
                    setCertifyError(true);
                }
                setLoading(false);
            })
            .catch(() => {
                setCertifyError(true);
                setLoading(false);
            });
    }

    return (
        <div>
            <Header page="export-center"/>
            {manuscriptError ?
                <div className={"submission-error"}>
                    <div>An error occurred while trying to load this submission.</div>
                    <div>Click <a href={"/submissions"}>here</a> to go back to the submissions page.</div>
                </div>
                :
                loading ? (
                    <Loading/>
                ) : (
                    <div className="body">
                        <div className="heading">Export Center</div>
                        <div className={"export-score-text"}>Choose how you would like to export your score:</div>
                        <div className={"search-bar-wrapper dashboard-row"}>
                            <div className={"submissions-input-half submissions-input-half-first hover-grey"}>
                                <span className={"export-icon"}><Download/></span>
                                <span className={"export-dropdown-text"}>Download</span>
                            </div>
                            <div className={"submissions-input-half hover-grey"}>
                                <span className={"export-icon"}><CgExport/></span>
                                <span className={"export-dropdown-text"}>Share</span>
                            </div>
                        </div>
                        {certifyError &&
                            <div className={"certify-submitted-text"} style={{border: '2px solid red'}}>
                                <div>We were unable to certify this submission. Please try again later.</div>
                            </div>
                        }
                        {certifyBanner &&
                            <div className={"certify-submitted-text"} style={{border: '2px solid green'}}>
                                <div>Congratulations! Your submission has been certified!</div>
                            </div>
                        }
                        {manuscript != null && !manuscript.certified &&
                            <div className={"search-bar-wrapper dashboard-row"} onClick={() => certifyManuscript()}>
                                <div className={"submissions-input-full hover-grey"}>
                                    <span className={"export-icon"}><BiPaperPlane/></span>
                                    <span className={"export-dropdown-text"}>Send in for Certification</span>
                                </div>
                            </div>
                        }
                        {/*<div className={"search-bar-wrapper dashboard-row"}>*/}
                        {/*    <div className={"submissions-input-full hover-grey"}>*/}
                        {/*        <span className={"export-icon"}><BiPaperPlane/></span>*/}
                        {/*        <span className={"export-dropdown-text"}>Send to Institution</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={"dashboard-row"}>
                            <div className={"export-table-wrapper box-shadow"}>
                                <table className={"export-table"}>
                                    <tbody>
                                    <tr className={"novelty-score"}>
                                        <td>Score:&nbsp;&nbsp;&nbsp;</td>
                                        <td>{calculateOverallScore(manuscript)}</td>
                                    </tr>
                                    <tr className={"export-table-tr"}>
                                        <td>Date Submitted:</td>
                                        <td>{new Date(manuscript.uploadDate).toLocaleDateString('en-US', {
                                            month: 'short',
                                            day: 'numeric',
                                            year: 'numeric'
                                        })}</td>
                                    </tr>
                                    <tr className={"export-table-tr"}>
                                        <td>Document Title:</td>
                                        <td style={{wordBreak: "break-word"}}>{manuscript.title != null ? manuscript.title : manuscript.name}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div className={"export-table-id"}>
                                    ID: {manuscript.key.replace(".pdf", "")}
                                </div>
                            </div>
                        </div>
                        <div className={"search-bar-wrapper dashboard-row"} style={{marginBottom: 0}}>
                            <div className={"export-bottom-switch-text"}>Include Subscores</div>
                            <label className="switch export-bottom-switch">
                                <input
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <div className={"search-bar-wrapper dashboard-row"} style={{marginTop: 0}}>
                            <div className={"export-bottom-switch-text"}>Add Personal Message</div>
                            <label className="switch export-bottom-switch">
                                <input
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <button onClick={() => navigate("/submission?id=" + id)}
                                className={"back-button fade-in"}
                        ><span className={"back-button-text"}>&larr;</span>
                        </button>
                    </div>
                )}
        </div>
    )
}

export default ExportCenter;